export default "__VITE_ASSET__BBKnONgj__"